import { render, staticRenderFns } from "./Wyroby.vue?vue&type=template&id=13d640e8&"
import script from "./Wyroby.vue?vue&type=script&lang=js&"
export * from "./Wyroby.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports